import {
    handleFloat,
    Base,
} from "../../index.js"

export default class Lissajous extends Base {
    constructor(options) {
        super(options)
        const defaults = {
            type: 'LISSAJOUS',
            name: 'Lissajous',

            theta: 1,
            delta: 0,
            constX: 7,
            constY: 6,
            increase_theta: 0.015,
            amplitudeX: 1,
            amplitudeY: 1
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name

        this.theta = opts.theta
        this.delta = opts.delta
        this.constX = opts.constX
        this.constY = opts.constY
        this.increase_theta = opts.increase_theta
        this.amplitudeX = opts.amplitudeX
        this.amplitudeY = opts.amplitudeY
    }

    set(key, newValue) {
        let config = {
            type: (data) => { return data.newValue },
            theta: handleFloat,
            delta: handleFloat,
            constX: handleFloat,
            constY: handleFloat,
            increase_theta: handleFloat,
            amplitudeX: handleFloat,
            amplitudeY: handleFloat
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatchToParent('objectStateChanged', this.propertyChangedMessage(key))
            }
        } else {
            Base.prototype.set.call(this, key, newValue)
        }
    }

    apply({ element, count, width, height, placeOnPath }) {
        const p5 = element.ctx
        const delta = this.delta * p5.PI
        let theta = (this.theta + (this.increase_theta * count))
        let x = this.amplitudeX * width / 2 * p5.sin(this.constX * theta + delta) + width / 2
        let y = this.amplitudeY * height / 2 * p5.sin(this.constY * theta) + height / 2;
        let x2, y2;

        if (!placeOnPath && element.type == "LINE") {
            theta = (this.theta + (this.increase_theta * (count + 1)))
            x = element.x + x 
            y = element.y + y
            x2 = element.x2 + x - element.x
            y2 = element.y2 + y - element.y
        }

        if (placeOnPath && element.type == "LINE") {
            theta = (this.theta + (this.increase_theta * (count + 1)))
            x2 = this.amplitudeX * width / 2 * p5.sin(this.constX * theta + delta) + width / 2
            y2 = this.amplitudeY * height / 2 * p5.sin(this.constY * theta) + height / 2;
        }

        element.setRenderPositionProperties({x, y, x2, y2})
    }

}
